import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const OnlineIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M3.33398 8.36655C4.65169 7.269 6.31239 6.66797 8.02732 6.66797C9.74225 6.66797 11.4029 7.269 12.7207 8.36655"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.947266 6.00084C2.89555 4.28348 5.40346 3.33594 8.0006 3.33594C10.5977 3.33594 13.1057 4.28348 15.0539 6.00084"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.6875 10.7392C6.3643 10.2583 7.17395 10 8.00417 10C8.83439 10 9.64403 10.2583 10.3208 10.7392"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 13.334H8.0075" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
